const getSites = async () => {
    let result = null
    try {
        result = await window.axios.get('/v1/sites/portfolio')
        const list = result.data.data;
        return list;
    } catch (err) {
        return Promise.reject(err)
    }
};

const getEquipmentForSite = async (siteId) => {
    let result = null
    try {
        result = await window.axios.get(`/v1/equipments/sites/${siteId}`)
        const list = result.data.data;
        return list;
    } catch (err) {
        return Promise.reject(err)
    }
};

const getEquipmentById = async (equipmentId) => {
    let result = null
    try {
        result = await window.axios.get(`/v1/equipments/${equipmentId}`)
        const list = result.data.data;
        return list;
    } catch (err) {
        return Promise.reject(err)
    }
};

const getEquipmentTypes = async () => {
    let result = null
    try {
        result = await window.axios.get(`/v1/equipmenttype/index`)
        const list = result.data.data;
        return list;
    } catch (err) {
        return Promise.reject(err)
    }
};

const createEquipment = async (equipment) => {
    try {
        await window.axios.post('/v1/equipments', equipment)
    } catch (err) {
        return Promise.reject(err)
    }
};

const updateEquipment = async (equipment) => {
    try {
        await window.axios.put(`/v1/equipments/${equipment.equipmentId}`, equipment)
    } catch (err) {
        return Promise.reject(err)
    }
};

const deleteEquipment = async (equipmentId) => {
    let result = null
    console.log(equipmentId);

    try {
        result = await window.axios.delete(`/v1/equipments/${equipmentId}`)
        const list = result.data.data;
        return list;
    } catch (err) {
        return Promise.reject(err)
    }
};

export default {
    getSites,
    getEquipmentTypes,
    getEquipmentForSite,
    getEquipmentById,
    createEquipment,
    updateEquipment,
    deleteEquipment,
}